<template>
    <b-row>
        <div class="col-lg-12 col-md-12 mt-2">
            <container-card id="exportar-cmv" icon="fa-filter" title="Faça o download dos valores calculados de CMV">
                <b-card>
                    <!-- FILTROS -->
                    <b-form>
                        <b-form-row>
                            <div class="col-md-12">
                                <b-form-row class="mb-2">
                                    <div class="col-md-6 col-sm-12">
                                        <b-form-group id="cmv_data_inicio_fim" label="Data de competência:">
                                             <el-date-picker
                                                v-model="filtros.month"
                                                type="month"
                                                placeholder="Selecione um mês"
                                                format="MM/yyyy"
                                                size="small"
                                                class="w-100" />
                                                        
                                            <message-validation :showError="showValidation == true"></message-validation>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-6 col-sm-12">
                                        <b-form-group id="empresas" :label="`Empresas${filtros.isCluster ? ' (Cluster)' : ''}:`" label-for="empresasASelect">
                                            <div class="toogle-multiselect-cluster">
                                                <small>{{ filtros.isCluster ? 'Alterar para empresas' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                                <el-switch 
                                                    v-b-popover.hover.top="'Alternar combo clusters/empresas.'"
                                                    v-model="filtros.isCluster" />
                                            </div>
                                            <div v-show="filtros.isCluster == false">
                                                <select2-multiple :options="listas.empresas" name="empresasASelect" v-model="filtros.empresas" :url="$urls.EMPRESAS"></select2-multiple>
                                            </div>
                                            <div v-show="filtros.isCluster == true">
                                                    <select2-multiple :options="listas.cluster" name="empresasACluster" v-model="filtros.clusterEmpresa" :url="$urls.DRE_LISTA_CLUSTER"></select2-multiple>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </b-form-row>
                            </div>
                        </b-form-row>
                    </b-form>
                    
                    <!-- BOTÕES DE AÇOES -->
                    <div slot="footer">
                        <div class="float-left btn-exportar">
                            <b-dropdown right size="sm" variant="success" style="width:110px;">
                                <template slot="button-content">
                                    <span v-if="filtros.loading === true">
                                        <i style="font-size: 15px; width: 85%; position: relative; left: 7px;" class="fas fa-spinner fa-pulse"></i>
                                    </span>
                                    <span v-else>
                                        <i class="fas fa-file-export"></i> Exportar
                                    </span>
                                </template>

                                <b-dropdown-item :disabled="filtros.loading === true" @click="exportarCMV">Exportar CMV</b-dropdown-item>
                                <b-dropdown-item :disabled="filtros.loading === true" @click="exportarPosicaoDeEstoque">Exportar posição de estoque</b-dropdown-item>
                                <b-dropdown-item :disabled="filtros.loading === true" @click="exportarEntradaDeEstoque">Exportar entrada de estoque</b-dropdown-item>
                                <b-dropdown-item :disabled="filtros.loading === true" @click="exportarCatalogoDePrecos">Exportar catálogo de preços</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </b-card>
            </container-card>
        </div>

        <div class="col-lg-12 col-md-12 mt-2">
            <container-card id="config-cmv" icon="fa-filter" title="Informe o plano de contas para o CMV">
                <b-card>
                    <!-- FILTROS -->
                    <b-form>
                        <b-form-row>
                            <div class="col-md-12">
                                <b-form-row class="mb-2">
                                    <div class="col-lg-4">
                                        <b-form-group id="planoDeContasCMV" label="Plano de Contas do CMV:" label-for="planoDeContasCMV" class="position-relative">
                                            <select2 required
                                                     :options="listas.planosDeContas"
                                                     name="planoDeContasCMV"
                                                     v-model="model.planoDeContasCMV">
                                            </select2>
                                        </b-form-group>
                                    </div>
                                    <div class="col-lg-4">
                                        <b-form-group id="planoDeContasCMV" label="Plano de Contas do Ajuste a Receber:" label-for="planoDeContasAjusteReceber" class="position-relative">
                                            <select2 required
                                                     :options="listas.planosDeContasReceber"
                                                     name="planoDeContasAjusteReceber"
                                                     v-model="model.planoDeContasAjusteReceber">
                                            </select2>
                                        </b-form-group>
                                    </div>
                                    <div class="col-lg-4">
                                        <b-form-group id="planoDeContasCMV" label="Plano de Contas do Ajuste a Pagar:" label-for="planoDeContasAjustePagar" class="position-relative">
                                            <select2 required
                                                     :options="listas.planosDeContas"
                                                     name="planoDeContasAjustePagar"
                                                     v-model="model.planoDeContasAjustePagar">
                                            </select2>
                                        </b-form-group>
                                    </div>
                                </b-form-row>
                            </div>
                        </b-form-row>
                    </b-form>

                    <!-- BOTÕES DE AÇOES -->
                    <div slot="footer">
                        <div class="float-left">
                            <button-validation @click.native="saveConfigPlanoDeContas" variant="primary" :hasLoad="!loadingPlanoDeContas" :disabled="loadingPlanoDeContas || !podeSalvarPlanoDeContas">
                                Salvar
                            </button-validation>
                        </div>
                    </div>
                </b-card>
            </container-card>
        </div>
    </b-row>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'
import Select2 from '@/components/shared/Select2'
import ButtonValidation from '@/components/shared/ButtonValidation'
import MessageValidation from '@/components/shared/MessageValidation'
import Select2Multiple from '@/components/shared/Select2Multiple'


    const listas = () => {
        return {
            planosDeContas: [],
            planosDeContasReceber: [],
            empresas: [],
            cluster: []
        }
    };

    const model = () => {
        return {
            planoDeContasCMV: '',
            planoDeContasAjusteReceber: '',
            planoDeContasAjustePagar: ''
        }
    };

    const filtros = () => {
        return {
            month: [],
            loading: false,
            isCluster: false,
            clusterEmpresa: [],
            empresas: []
        }
    }

    var exportar = (self, url) => {

        
        if (self.validarCalendario() && url != self.$urls.ESTOQUE_EXPORTAR_CATALOGO_PRECOS) {
            self.showValidation = true;
            return;
        }
        else if(url == self.$urls.ESTOQUE_EXPORTAR_CATALOGO_PRECOS){
            self.showValidation = false;
        }

        self.filtros.loading = true;

        let value = {
            inicio: self.moment(self.filtros.month).format('YYYY-MM-DD'),
            clustersIds: self.filtros.clusterEmpresa,
            empresasIds: self.filtros.empresas
        }

        self.$blob.postDownload(url, value, () => {
            self.filtros.loading = false;
        });
    }

export default {
    name: 'dre',
    components: {
        'button-validation': ButtonValidation,
        'container-card': ContainerCard,
        'select2': Select2,
        MessageValidation,
       'select2-multiple': Select2Multiple,
    },
    data(){
        return {
            listas: listas(),
            model: model(),
            filtros: filtros(),
            loadingPlanoDeContas: false,
            showValidation: false,
        }
    },
    computed: {
        podeSalvarPlanoDeContas(){
            return !this.isNullOrEmpty(this.model.planoDeContasCMV)
        }
    },
    methods: {
        saveConfigPlanoDeContas() {
            const self = this
            this.loadingPlanoDeContas = true;
            var postModel = { 
                planoDeContasCMVId: self.model.planoDeContasCMV,
                planoDeContasAjusteReceberId: self.model.planoDeContasAjusteReceber,
                planoDeContasAjustePagarId: self.model.planoDeContasAjustePagar 
            };
            this.axios.post(self.$urls.CLIENTE_SETUP_SAVE, postModel).then((res) => {               
                self.showValidationUpload = false

                if (res.data) {
                    self.$message({
                        showClose: true,
                        message: 'Registro salvo com sucesso.',
                        type: 'success',
                        duration: 4000
                    });

                    self.loadingPlanoDeContas = false
                }
            });
        },
        exportarCMV() {
            const self = this
            exportar(self, self.$urls.ESTOQUE_EXPORTAR_CMV);
        },
        exportarPosicaoDeEstoque() {
            const self = this
            exportar(self, self.$urls.ESTOQUE_EXPORTAR_POSICAO_ESTOQUE);
        },
        exportarEntradaDeEstoque() {
            const self = this
            exportar(self, self.$urls.ESTOQUE_EXPORTAR_ENTRADA_ESTOQUE);
        },
        exportarCatalogoDePrecos() {
            const self = this
            exportar(self, self.$urls.ESTOQUE_EXPORTAR_CATALOGO_PRECOS);
        },
        validarCalendario(){
            return this.isNullOrEmpty(this.filtros.month)
        },
        handleCluster(isCluster){
            if(isCluster){
                this.filtros.empresas = []
            }else{
                this.filtros.clusterEmpresa = []
            }
        }
    },
    created() {
        const self = this;

        var obterConfigSalva = function () {
            self.axios.get(self.$urls.CLIENTE_SETUP_GET).then((dt) => {
                if (!dt || !dt.data || !dt.data.planoDeContasCMV) {
                    return false;
                }

                self.model.planoDeContasCMV = dt.data.planoDeContasCMV._id;
                if(dt.data.planoDeContasAjusteReceber){
                    self.model.planoDeContasAjusteReceber = dt.data.planoDeContasAjusteReceber._id;
                }
                if(dt.data.planoDeContasAjustePagar){
                    self.model.planoDeContasAjustePagar = dt.data.planoDeContasAjustePagar._id;
                }
                
                console.log(dt);
            });
        }

        self.axios.get(self.$urls.PLANO_DE_CONTAS_APAGAR).then((dt) => {
            if (!dt) {
                self.listas.planosDeContas = []
                return false
            }

            self.listas.planosDeContas = dt.data;
            obterConfigSalva();
        });

        self.axios.get(self.$urls.PLANO_DE_CONTAS_ARECEBER).then((dt) => {
            if (!dt) {
                self.listas.planosDeContasReceber = []
                return false
            }

            self.listas.planosDeContasReceber = dt.data;
            obterConfigSalva();
        });

        self.$root.$on('empresasASelectOptions',function(data){
            self.listas.empresas = data
        })

        self.$root.$on('empresasAClusterOptions',function(data){
            self.listas.cluster = data
        })

    },
    watch: {
        filtros: {
            deep: true,

            handler(){
                if(this.validarCalendario()){
                    this.showValidation = true
                }else{
                    this.showValidation = false
                }
            }
        },
        'filtros.isCluster': function(currentValue){
            this.handleCluster(currentValue)
        }
    }
}
</script>

<style>
    .el-picker-panel {
        z-index: 999999 !important;
    }
    /* zindex alto para ficar acima de todos os components */
    .upload-valores {
        width: 100%;
    }

    .el-upload-list__item i.el-icon-close {
        display: none !important;
    }

    input.v-money {
        border-radius: 3px;
        border: 1px solid #c5c1c1;
        text-align: right;
        padding-right: 5px;
        width: 100%;
    }

    .list-group-import {
        font-size: 12px;
        transition: 0.3s;
    }

        .list-group-import:hover {
            background: #feffc9;
        }

        .list-group-import .badge {
            font-size: 10px;
            height: 18px;
            position: relative;
            left: -11px;
        }

    .div-mask-cell {
        width: 90%;
        height: 100%;
        position: absolute;
        top: 0;
        background: transparent;
        cursor: pointer;
    }

    .load-edit-valor, .edit-valor-lapis {
        position: absolute;
        top: 9px;
        left: 14px;
    }

    .edit-valor-lapis {
        font-size: 13px;
        width: 10px;
        height: 10px;
        cursor: text;
        top: 7px;
    }

    .success-edit-valor {
        position: absolute;
        top: 9px;
        right: -110px;
        color: #01960d;
    }

    .input-valor-manual {
        background: #c5c1c1;
    }

        .input-valor-manual:focus {
            background: #fff;
        }

    .btn-exportar {
        @media screen and (max-width: 440px) {
            width: 98% !important;
            margin: 2px;
            .btn-group {
                width: 100% !important;
            }
        }
    }

</style>